import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useListLeagueHomeVenues } from "../api/LeagueVenueApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { useCreateLeagueMatch, useRetrieveSeason, } from "../api/SeasonApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { LeagueMatchForm } from "./LeagueMatchForm";
export var CreateLeagueMatch = function () {
    var _a;
    var _b = useNumericParams(), leagueId = _b.leagueId, seasonId = _b.seasonId;
    var navigate = useNavigate();
    var _c = useRetrieveUserLeaguePermissions({ leagueId: leagueId }), permissions = _c.data, permissionsLoading = _c.isLoading, permissionsError = _c.error;
    var _d = (permissions || {}).canModify, canModify = _d === void 0 ? false : _d;
    var _e = useRetrieveSeason({ id: seasonId, enabled: canModify }), season = _e.data, seasonLoading = _e.isLoading, seasonError = _e.error;
    var _f = useListLeagueHomeVenues({ leagueId: leagueId, enabled: canModify }), _g = _f.data, leagueVenues = _g === void 0 ? [] : _g, venuesLoading = _f.isLoading;
    var mutation = useCreateLeagueMatch({
        onSuccess: function (response) {
            navigate("/leagues/".concat(leagueId, "/seasons/").concat(seasonId, "?tab=fixtures&division=").concat(response.data.division));
        },
    });
    var onSubmit = function (data) {
        mutation.mutate(data);
    };
    if (permissionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (seasonLoading || venuesLoading) {
        return _jsx(Loading, {});
    }
    if (seasonError || !season) {
        return _jsx(ErrorView, { error: seasonError });
    }
    var divisions = (_a = season.divisions) !== null && _a !== void 0 ? _a : [];
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to create match. Please try again." }), _jsx(Typography, { variant: "h6", children: _jsx("strong", { children: "Create League Match" }) }), _jsx(LeagueMatchForm, { divisions: divisions, leagueVenues: leagueVenues, onSubmit: onSubmit, isSubmitting: mutation.isLoading })] }));
};
